import { red } from "@material-ui/core/colors";
import { createTheme } from "@material-ui/core/styles";

// A custom theme for this app
const light = {
  palette: {
    common: {
      black: "#222",
    },
    primary: {
      main: "#474eff",
    },
    secondary: {
      main: "#e45858",
    },
    error: {
      main: red.A400,
    },
    text: {
      primary: "#202124",
      secondary: "#20212480",
    },
    background: {
      default: "#f2f2f7",
      paper: "#ffffff",
      input: "#ffffff",
    },
    divider: "rgba(145, 158, 171, 0.4)",
  },
  shape: {
    borderRadius: 8,
  },
  layout: {
    drawerWidth: 240,
  },
  typography: {
    fontFamily: [
      "Open Sans",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    subtitle1: {
      fontWeight: 500,
    },
    button: {
      fontWeight: 800,
    },
    body1: {
      fontSize: "0.9375rem",
    },
    body2: {
      fontSize: "0.9375rem",
    },
  },
  overrides: {
    MuiFilledInput: {
      input: {
        borderRadius: "4px",
        background: "#f0f3f5",
      },
    },
    MuiButton: {
      root: {
        borderRadius: "4px",
        textTransform: "none",
      },
      contained: {
        boxShadow: "none",
        backgroundColor: "#e8edf4",
      },
      containedPrimary: {
        color: "#fff",
      },
    },
  },
};

const dark = {
  palette: {
    primary: {
      main: "#20B8F0",
    },
    type: "dark",
  },
  layout: {
    drawerWidth: 240,
  },
};

export const defaultTheme = createTheme(light);
export const darkTheme = createTheme(dark);
